import styled from '@emotion/styled';

const MDXStyledP = styled.p`
  padding: 0 0 6px;
  line-height: 1.5;
  font-size: 1rem;
`;

export default MDXStyledP;
